import React from 'react'
import PropTypes from 'prop-types'

import { cx } from 'passiv-libs'

import { Paper, Text, Icon } from 'passiv-components'
import InOut from './in-out'
import Heating from './heating'
import Away from './away'
import HotWater from './hot-water'

const Tile = ({
  id,
  loading,  
  dataContainer,
  awayTile = {},
  disabled,
  colour,
  badge,
  occupancy,
  untilTimeText,
  name,
  ariaLabel,
  airTemperature,
  airTemperatureAriaLabel,
  icon,
  link,
  onClick
}) => {
  return id === 'in-out' ? (
    <Paper 
      className="w-full h-full select-none cursor-pointer relative flex-col flex-center menu-tile md:menu-tile"
      dataContainer={dataContainer}
    >
      {/* NB clickable div covers whole tile */}
      <div
        className="absolute z-10 w-full h-full left-0 top-0"
        onClick={() => onClick({ id: 'in-out' })}
      />
      {/* NB clickable override text inside <InOut/> has higher z-index */}
      <InOut
        name={name}
        ariaLabel={ariaLabel}
        occupancy={occupancy}
        untilTimeText={untilTimeText}
        onToggleClick={() => onClick({ id: 'in-out' })}
        onUntilTimeClick={() => onClick({ id: 'in-out--override-out' })}
      />
    </Paper>
  ) : id === 'heating' ? (
    <Paper
      className="overflow-hidden w-full h-full select-none cursor-pointer relative flex-col flex-center menu-tile md:menu-tile"
      dataContainer={dataContainer}
      onClick={() => onClick({ id: 'heating', link })}
      ariaRole="button"
      ariaLabel={`${name}${airTemperatureAriaLabel}`}
    >
      <Heating
        loading={loading}
        name={name}
        link={link}
        airTemperature={airTemperature}
        occupancy={occupancy}
      />
    </Paper>
  ) : id === 'away' ? (
    <Paper
      className="w-full h-full select-none cursor-pointer relative flex-col flex-center"
      dataContainer={dataContainer}
      onClick={() => onClick({ id: 'away' })}
      ariaRole="button"
      ariaLabel={awayTile.label}
    >
      <Away loading={loading} icon={icon} badge={badge} awayTile={awayTile} occupancy={occupancy} />
    </Paper>
  ) : id === 'hot-water' ? (
    <Paper
      className="w-full h-full select-none cursor-pointer relative flex-col flex-center"
      dataContainer={dataContainer}
      onClick={() => onClick({ id, link })}
      ariaRole="button"
      ariaLabel="Hot water"
    >
      <HotWater icon={icon} colour={colour} />
    </Paper>
  ) : (
    <Paper
      className="w-full h-full select-none cursor-pointer relative flex-col flex-center"
      dataContainer={dataContainer}
      onClick={() => onClick({ id, link })}
      ariaRole="button"
      ariaLabel={(ariaLabel) ? ariaLabel : name}
    >
      <Text
        type="title-condensed"
        className="sm:menu-tile-title absolute pt-2 top-0 w-full text-center"
        ariaHidden={true}
      >
        {name}
      </Text>
      <Icon
        className={cx('w-12 h-9 sm:w-9', {
          ['text-in-red']: colour === 'in-red',
          ['text-out-grey']: colour === 'out-grey',
          ['text-away-grey']: colour === 'away-grey',
          ['text-blue']: colour === 'blue'
        })}
        icon={icon}
        badge={badge < 0 ? 0 : badge}
      />
    </Paper>
  )
}

Tile.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  awayTile: PropTypes.object,
  badge: PropTypes.number,
  occupancy: PropTypes.array,
  untilTimeText: PropTypes.string,
  name: PropTypes.string,
  airTemperature: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func
}

export default Tile
